<template>
  <div class="rightBar">
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'RightBar',
    data: () => ({
    }),
    created() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.rightBar {
  position: sticky;
  top: 20px;
  width: 19.2%;
  // min-width: 250px;
}
// 小屏
@include mq($small) {
  .rightBar {
    position: sticky;
    top: 20px;
    // width: 28%;
  }
}
</style>
